import { createSafeContext, useSafeContext } from '@utilities/context';

import type { NavLayoutUser } from './types';

export interface ContextValue {
  user?: NavLayoutUser;
  onLogin?: () => void;
  onBanxaBuyToken?: () => void;
  showKyc?: boolean;
}

export const NavLayoutContext = createSafeContext<ContextValue>();

export const useNavLayout = () => useSafeContext(NavLayoutContext);
